
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gCNRwKXoiHpg4lRROoXB_skxPsuSCG4_HQFMM80nK2x8Meta } from "/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexZtLd6ofQfMZLHxZsXygMDfgenC8qHyL9_45aQXFW64faEMeta } from "/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchJ664xF1AI5O6esMdwvZ0PWT46trqffxS5NBJMolb_zIMeta } from "/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexFm_wZninoNa4UuoZW2Mca8UHUtm4kRwQaV8wCacsx6YMeta } from "/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93s2_4549JHj2asHIqVtwYwSrg8vlGMVnCtl8f0Nxe0p2zUMeta } from "/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexnlvK7UUMqEDDDsA_45qqjP_45LnIcy0IB8YZTqwwhFscTI8Meta } from "/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_9338zLvzfaPjQiZfPM2P4Bqzgrf72dwX2hDIfoQZhSWrMMeta } from "/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index_OV3X_45Ff8YegcCxI1MNs3O2j0fc82Bd0HllFmKVsUQUMeta } from "/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93KO1OYuOYrlRs8uvNcavul1jAaldXFkRPNc9V4XVK8IIMeta } from "/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index5i7M1VrBj_45fYMKui8VY03kQy7rgCOILH6xGfp44RhtMMeta } from "/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexh2kXk2UGSEB5rJP7agCvpOGqS57N3E82ledur7_45UPUMMeta } from "/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexnlvK7UUMqEDDDsA_45qqjP_45LnIcy0IB8YZTqwwhFscTI8Meta || {},
    component: () => import("/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index_OV3X_45Ff8YegcCxI1MNs3O2j0fc82Bd0HllFmKVsUQUMeta || {},
    component: () => import("/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index5i7M1VrBj_45fYMKui8VY03kQy7rgCOILH6xGfp44RhtMMeta || {},
    component: () => import("/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexh2kXk2UGSEB5rJP7agCvpOGqS57N3E82ledur7_45UPUMMeta || {},
    component: () => import("/codebuild/output/src744762785/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]